export default __webpack_public_path__ + "static/media/SkillsStar2.a361cf9c.png";